import { BaseDialog } from '@components/dialog';
import { BtnPrimary } from '@components/buttons';

/**
 * SuccessModal - Displayed after successfully publishing a calendar page
 *
 * This modal celebrates the user's accomplishment and provides guidance on next steps
 * after their coaching page has been successfully published. It's shown when the user
 * completes the publishing process from the page builder.
 *
 * Used in: /calendar/page-builder with ?modal=success query parameter
 */

export function SuccessModal({ hide }: { hide: () => void }) {
  return (
    <BaseDialog onClose={hide} contentWidth>
      <section class="p-10 text-base w-xl flex flex-col gap-6 overflow-auto  leading-normal">
        <header class="flex items-center text-center flex-col gap-4">
          <div class="inline-flex items-center justify-center size-16 rounded-full bg-gradient-to-br from-sky-600 to bg-pink-400 via-violet-400 text-2xl">
            🎉
          </div>

          <h1 class="capitalize text-3xl font-bold">Welcome to CoachMira</h1>

          <p class="text-gray-600 text-lg leading-normal">
            Welcome to the Coach Mira community! Your coaching page is ready and you're all set to
            start building your coaching business. Let's get your first clients!
          </p>
        </header>

        <section class="bg-gray-50 rounded-xl p-6 flex flex-col gap-4 shadow-sm shadow-violet-200 border-t border-teal-200/50">
          <header class="flex items-center flex-col gap-2">
            <h2 class="capitalize text-xl font-bold">Here's what you can do now</h2>
          </header>
          <ul class="text-gray-600 flex flex-col gap-6">
            <li class="flex gap-4">
              <span class="flex items-center justify-center size-12 rounded-full bg-violet-100 text-violet-600 shrink-0">
                📢
              </span>
              <div>
                <h3 class="font-bold">Share</h3>
                Share your coaching page with the world.
              </div>
            </li>
            <li class="flex gap-4">
              <span class="flex items-center justify-center size-12 rounded-full bg-violet-100 text-violet-600 shrink-0">
                📅
              </span>
              <div>
                <h3 class="font-bold">Book clients</h3>
                Start booking clients right away.
              </div>
            </li>
          </ul>
        </section>

        <p class="text-xs text-gray-500 text-center">
          We're here to help. Reach out anytime. We want to support you in every step of your
          journey.
        </p>
        <footer class="flex justify-center">
          <BtnPrimary class="rounded-full py-4 px-8 bg-violet-600" onClick={hide}>
            Let's get started together
          </BtnPrimary>
        </footer>
      </section>
    </BaseDialog>
  );
}
